import * as React from 'react'
import { reduxForm, InjectedFormProps } from 'redux-form'
import { FormGroup, Button, Alert } from 'react-bootstrap'
import * as moment from 'moment'

import { BASIC } from '../../constants/DateFormat'
import { FORM_CREATE_LOAN } from '../../constants/Form'
import {
  CREATE_LOAN_FORM_CREDITOR,
  CREATE_LOAN_FORM_DEBTORS,
  CREATE_LOAN_FORM_DESCRIPTION,
  CREATE_LOAN_FORM_INTERVAL,
  CREATE_LOAN_FORM_INTEREST,
  CREATE_LOAN_FORM_STARTED_ON,
  CREATE_LOAN_FORM_AMOUNT
} from '../../constants/CreateLoanFormFieldName'
import { InputControlField } from '../../components/form/InputControl'
import { UserSelectControlField } from '../../components/form/UserSelectControl'
import { DatepickerControlField } from '../../components/form/DatepickerControl'
import {
  SelectControlField,
  SelectOption
} from '../../components/form/SelectControl'
import { IntervalType } from '../../types'
import { isRequired, isNumber } from '../../utils/validators'
import { ApolloError } from 'apollo-client'

export interface CreateLoanFormData {
  amount: string
  creditor: SelectOption
  debtors: SelectOption[]
  description: string
  interest: string
  interval: SelectOption
  startedOn: moment.Moment
}

interface CreateLoanFormOwnProps {
  formError?: ApolloError
}

export type CreateLoanFormProps = InjectedFormProps<
  CreateLoanFormData,
  CreateLoanFormOwnProps
> &
  CreateLoanFormOwnProps

const atLeastOne = value =>
  value && value.length === 0
    ? 'Je třeba vybrat alespoň jednoho uživatele'
    : undefined

const IntervalOptions: SelectOption[] = [
  {
    label: 'Měsíčně',
    value: IntervalType.MONTHLY
  },
  {
    label: 'Čtvrtletně',
    value: IntervalType.QUARTERLY
  },
  {
    label: 'Ročně',
    value: IntervalType.ANNUALY
  }
]

const CreateLoanForm: React.SFC<CreateLoanFormProps> = ({
  handleSubmit,
  formError
}) => {
  const now = moment()

  return (
    <form onSubmit={handleSubmit}>
      <UserSelectControlField
        name={CREATE_LOAN_FORM_CREDITOR}
        label="Věřitel"
        validate={isRequired}
      />
      <UserSelectControlField
        name={CREATE_LOAN_FORM_DEBTORS}
        label="Dlužníci"
        validate={[isRequired, atLeastOne]}
        multi={true}
      />
      <InputControlField
        label="Účel"
        name={CREATE_LOAN_FORM_DESCRIPTION}
        type="text"
        placeholder="Účel"
      />
      <InputControlField
        label="Částka"
        name={CREATE_LOAN_FORM_AMOUNT}
        type="number"
        placeholder="Částka"
        validate={[isRequired, isNumber]}
      />
      <InputControlField
        label="Úrok"
        name={CREATE_LOAN_FORM_INTEREST}
        type="number"
        placeholder="Úrok"
        validate={[isRequired, isNumber]}
      />
      <DatepickerControlField
        label="Dne"
        className="form-control"
        dateFormat={BASIC}
        placeholderText={moment().format(BASIC)}
        name={CREATE_LOAN_FORM_STARTED_ON}
        filterDate={date => date.isBefore(now)}
      />
      <SelectControlField
        label="Interval"
        name={CREATE_LOAN_FORM_INTERVAL}
        options={IntervalOptions}
      />
      <FormGroup>
        <Button id="create-loan" bsStyle="primary" type="submit">
          Vytvořit půjčku
        </Button>
      </FormGroup>
      <FormGroup>
        {formError && <Alert bsStyle="danger">{formError.message}</Alert>}
      </FormGroup>
    </form>
  )
}

export default reduxForm<CreateLoanFormData, CreateLoanFormOwnProps>({
  form: FORM_CREATE_LOAN
})(CreateLoanForm)



// WEBPACK FOOTER //
// ./src/screens/createLoan/CreateLoanForm.tsx